/* jshint esversion: 6 */

'use strict';

import Alpine from 'shared/js/alpinejs';
import widget from './component/promotionWidget/widget';

document.addEventListener('alpine:collect-components', function () {
    Alpine.data('customerPersonalPromotion', widget);
});
